import React from 'react';
import {
  Inbox,
  QrCode2,
  Dashboard,
  AccountTree,
  History as HistoryIcon,
  Campaign,
  Psychology,
  TrendingUp,
  VerifiedUser,
  CloudDone,
  SupportAgent,
} from '@mui/icons-material';

export interface CondoFeatureItem {
  icon: React.ReactElement;
  title: string;
  description: string;
}

export interface CondoAiFeatureItem extends CondoFeatureItem {
  benefits: string[];
}

export const features: CondoFeatureItem[] = [
  {
    icon: React.createElement(Inbox, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Centralize todas as demandas',
    description:
      'Receba solicitações em um único painel organizado, com histórico, status e acompanhamento em tempo real. Nunca mais perca uma demanda em conversas do WhatsApp.',
  },
  {
    icon: React.createElement(QrCode2, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Abertura rápida por QR Code',
    description:
      'Moradores podem registrar problemas em segundos através de QR Codes nas áreas comuns que direcionam para formulários simples e rápidos para preencher.',
  },
  {
    icon: React.createElement(Dashboard, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Mais controle para o síndico',
    description:
      'Acompanhe tudo o que está acontecendo no condomínio com muito mais organização, transparência e rastreabilidade.',
  },
  {
    icon: React.createElement(AccountTree, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Atendimento mais organizado',
    description:
      'Transforme mensagens soltas em um fluxo profissional de atendimento, facilitando a priorização e resolução das demandas.',
  },
  {
    icon: React.createElement(HistoryIcon, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Histórico completo e rastreável',
    description:
      'Tenha acesso ao histórico completo das solicitações, responsáveis, movimentações e andamento de cada demanda.',
  },
  {
    icon: React.createElement(Campaign, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Notificações automáticas',
    description:
      'Síndicos e equipes recebem notificações automáticas sobre novas demandas e atualizações importantes da operação.',
  },
];

export const aiFeatures: CondoAiFeatureItem[] = [
  {
    icon: React.createElement(Psychology, { sx: { fontSize: 50, color: '#9c27b0' } }),
    title: 'Análise de Similaridade com IA',
    description:
      'Com o uso de inteligência artificial é possível identificar automaticamente demandas similares ou duplicadas, agrupando-as para facilitar a resolução. Economize tempo e evite trabalho duplicado.',
    benefits: [
      'Detecção automática de demandas similares',
      'Agrupamento inteligente por contexto',
      'Redução de trabalho duplicado',
      'Identificação de padrões recorrentes',
    ],
  },
  {
    icon: React.createElement(TrendingUp, { sx: { fontSize: 50, color: '#1976d2' } }),
    title: 'Análise de Tendências com IA',
    description:
      'Identifique problemas recorrentes antes que se tornem críticos. Com o uso de IA é possível analisar padrões nas demandas e sugere ações preventivas e corretivas baseadas em dados reais.',
    benefits: [
      'Identificação proativa de problemas recorrentes',
      'Recomendações de ações preventivas',
      'Análise de severidade (Crítico, Atenção, Monitorar)',
      'Acompanhamento de eficácia das correções aplicadas',
    ],
  },
];

export const trustFeatures: CondoFeatureItem[] = [
  {
    icon: React.createElement(VerifiedUser, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Segurança em Primeiro Lugar',
    description:
      'Seus dados são protegidos com as melhores práticas de segurança. Isolamento completo entre condomínios e criptografia de ponta a ponta.',
  },
  {
    icon: React.createElement(CloudDone, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Backup Automático',
    description: 'Seus dados são automaticamente salvos e protegidos. Nunca perca informações importantes.',
  },
  {
    icon: React.createElement(SupportAgent, { sx: { fontSize: 40, color: 'primary.main' } }),
    title: 'Suporte Dedicado',
    description:
      'Nossa equipe está sempre pronta para ajudar. Suporte técnico rápido e eficiente quando você precisar.',
  },
];
